import { render } from "./VueDatePicker.vue?vue&type=template&id=66681572&ts=true"
import script from "./VueDatePicker.vue?vue&type=script&lang=ts"
export * from "./VueDatePicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__